import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";

import Layout from "../../../Layout";
import VerticalStepper from "../../../components/stepper";
import GeneralInformation from "./components/GeneralInfo";
import TradingAddress from "./components/TradingAddress";
import CustomerPortfolio from "./components/CustomerPortfolio";
import ActiveServices from "./components/Services";
import NoKeyPersonnel from "../../../components/entities/key-personnel/NoKeyPersonnel";
import Personnel from "../../../components/entities/key-personnel/Personnel";
import ConfirmationDialog from "../../../components/confirmation-dialog/ConfirmationDialog";
import OnboardSuccess from "./components/OnboardSuccess";

import useLspOnboarding from "../actions/useLspOnboarding";
import useLspGenInfo from "../actions/useLspGenInfo";
import useLspAddress from "../actions/useLspAddress";
import useLspServices from "../actions/useLspServices";
import { useCallbackPrompt } from "../../../hooks/useCallbackPrommpt";

import "../lsponboard.scss";

const LSPOnboarding = () => {
  const navigate = useNavigate();

  const { onChangeGeneralInfo, generaldata } = useLspGenInfo();
  const { onChangeAddress, tradingdata, statesarray, cityarray } =
    useLspAddress();
  const { stateValues, handleServiceChange, handleServiceUpdate } =
    useLspServices();

  const {
    gendata,
    handleNext,
    handleBack,
    setPersonnelList,
    handleSave,
    handleViewLsp,
    closeLspWizard,
    handleClearState,
  } = useLspOnboarding();

  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
    gendata?.isLeaveModal,
  );

  const handleLeaveConfirm = () => {
    handleClearState();
    confirmNavigation();
  };

  const steps = [
    {
      label: "General Information",
      content: (
        <GeneralInformation
          handleChange={onChangeGeneralInfo}
          generaldata={generaldata}
        />
      ),
    },
    {
      label: "Trading Address",
      content: (
        <TradingAddress
          handleChange={onChangeAddress}
          data={tradingdata}
          states={statesarray}
          cities={cityarray}
        />
      ),
    },
    {
      label: "Active Services",
      content: (
        <ActiveServices
          list={stateValues?.entityservices}
          selected={stateValues?.serviceList}
          handleChange={handleServiceChange}
          handleUpdate={handleServiceUpdate}
        />
      ),
    },
    {
      label: "Customer Portfolio",
      content: <CustomerPortfolio />,
    },
    {
      label: "Key Personnel",
      content: (() => {
        if (gendata?.personnelLists.length === 0) {
          return (
            <NoKeyPersonnel
              showKeyPersonnel={true}
              personnelState={gendata?.personnelLists}
              setPersonnelState={setPersonnelList}
            />
          );
        } else {
          return (
            <Personnel
              showKeyPersonnel={true}
              personnelState={gendata?.personnelLists}
              setPersonnelState={setPersonnelList}
              isCongrats={false}
            />
          );
        }
      })(),
    },
  ];
  return (
    <Layout
      crumbs={[
        {
          label: (
            <span style={{ textDecoration: "underline", cursor: "pointer" }}>
              Local Teams
            </span>
          ),
          command: () => navigate("/entities"),
          id: "entities",
        },
        { label: "Add New Local Team", id: "add-lsp" },
      ]}
    >
      <div className="grid lsp-onboarding">
        <div className="lg:col-3 md:col-12 sm:col-12 xs:col-12 pt-4">
          <Card className="card-lsp">
            <p className="add-new-entity-heading">Add New Local Team</p>
            <p className="input-label m-0">
              Complete the necessary steps to onboard a new Local Team.
            </p>
            <Divider />
            <div className="step-menu">
              <VerticalStepper
                options={steps}
                activeIndex={gendata?.activeIndex}
              />
            </div>
          </Card>
        </div>
        <div className="lg:col-9 md:col-12 sm:col-12 xs:col-12 pt-4">
          <Card className="card-onboard">
            {gendata?.status === "lsponboardsucces" ? (
              <OnboardSuccess
                handleView={handleViewLsp}
                handleClose={closeLspWizard}
              />
            ) : (
              steps[gendata?.activeIndex]?.content
            )}
          </Card>

          {gendata?.status !== "lsponboardsucces" && (
            <div className="btn-footer">
              <div className="cancel-container">
                <a
                  className="cancel-link"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Cancel
                </a>
              </div>

              <div className="action-buttons">
                {gendata?.activeIndex !== 0 && (
                  <Button
                    onClick={handleBack}
                    disabled={gendata?.activeIndex === 0}
                    className="cancel-btns"
                  >
                    Back
                  </Button>
                )}
                {gendata?.activeIndex === 4 ? (
                  <Button
                    type="submit"
                    className={`add-new-contact complete-onboard-btn ${!gendata?.onboardBtnEnable && "disable"}`}
                    disabled={
                      !gendata?.onboardBtnEnable ||
                      gendata?.status === "lsponboardloading"
                    }
                    loading={
                      gendata?.status === "lsponboardloading" ? true : false
                    }
                    onClick={() => {
                      handleSave();
                    }}
                  >
                    {gendata?.status !== "lsponboardloading" &&
                      "Complete Onboarding"}
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    onClick={handleNext}
                    disabled={!gendata?.nextBtnEnable}
                    className={`add-new-lsp  ${!gendata?.nextBtnEnable && "disable"}`}
                  >
                    Next
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {showPrompt && (
        <ConfirmationDialog
          show={showPrompt}
          onConfirm={handleLeaveConfirm}
          onCancel={cancelNavigation}
        />
      )}
    </Layout>
  );
};

export default LSPOnboarding;
